import type { ThemeTypes } from '@/types/themeTypes/ThemeType';

const SHARED_COLORS = {
    primaryLightest: '#16293e',
    primary1: '#CCEBFF',
    primary2: '#9ED8FF',
    primary3: '#6BC4FF',
    primary5: '#0A9DFF',
    primary7: '#0062A3',

    greyLightest: '#111C2D',
    grey1: '#F2F6FA',
    grey2: '#F0F5F9',
    grey3: '#DFE5EF',
    grey4: '#7C8FAC',
    grey5: '#5A6A85',

    success1: '#E3F8ED',
    success4: '#A6E8C6',
    success5: '#69D89F',
    success6: '#5ecf96',

    infoLightest: '#F1FBFE',
    info1: '#DFF6FC',
    info2: '#C3EEF9',
    info3: '#A3E5F5',
    info4: '#83DBF2',
    info5: '#67D3EF',
    info7: "#16AACF",

    orange1: '#FEEFEB',
    orange5: '#FCA792',

    indigoLightest: '#F4F0FA',
    indigo1: '#E9E1F4',
    indigo5: '#8C62C6',

    amber1: '#FEF2CA',
    amber5: '#F49C2B',

    lime: '#67A228',
    lime1: '#ECFBCE',
    lime3: '#BFF071',
    lime5: '#86CA36',

    teal: '#179488',
    teal1: '#CDFBF1',
    teal3: '#63EAD5',
    teal5: '#20B8A6',
    teal7: '#15766E',
    
    pink: '#D92876',
    pink1: '#FCE7F3',
    pink5: '#EA4A97',

    purple: '#7543B9',
    purple1: '#E9E1F4',
    purple3: '#BAA1DD',

    errpr1: "#FEEFEB",
    error3: "#FDCBBF",
    error7: "#F84C20",

    warning6: "#FDD835",
    warning8: "#AF6709",

    whatsappBg: "#f0fdfa",
    whatsappIconBg: "#CDFBF1",
    whatsappPrimary: "#20B8A6",
};

const DARK_BLUE_THEME: ThemeTypes = {
    name: 'DARK_BLUE_THEME',
    dark: true,
    variables: {
        'border-color': '#182D41', 
        'border-opacity': 1,
    },
    colors: {
        primary: '#0085db', 
        secondary: '#7C8FAC',
        info: '#5AC8FA',
        success: '#09C97F', 
        warning: '#F8B15D', 
        error: '#FB977D', 
        orange: '#FB977D',
        indigo:'#8763DA',  
        lightprimary: '#1b394f',
        lightinfo:'#1a3247', 
        lightsecondary: '#2f3f4c',
        lightsuccess: '#102d35', 
        lighterror: '#72483d',
        lightwarning: '#282b32', 
        textPrimary: '#EAEFF4',
        textSecondary: '#fff',
        lightindigo:'#1d233e',  
        borderColor: '#182D41', 
        inputBorder: '#646c79',
        containerBg: '#111C2D', 
        background: '#16293e', 
        hoverColor: '#333f55',
        surface: '#111C2D', 
        grey100: '#7C8FAC', 
        grey200: '#EAEFF4', 
        darkbg:'#111936',
        bglight:'#16293e',
        bgdark:'#16293e',
        ...SHARED_COLORS
    }
};

const DARK_AQUA_THEME: ThemeTypes = {
    name: 'DARK_AQUA_THEME',
    dark: true,
    variables: {
        'border-color': '#333F55',
        'border-opacity': 1,
    },
    colors: {
        primary: '#0074BA',
        secondary: '#47D7BC',
        info: '#5AC8FA',
        success: '#09C97F', 
        warning: '#F8B15D', 
        error: '#FB977D', 
        orange: '#FB977D',
        indigo:'#8763DA',  
        lightprimary: '#1b394f',
        lightinfo:'#1a3247', 
        lightsecondary: '#2f3f4c',
        lightsuccess: '#102d35', 
        lighterror: '#72483d',
        lightwarning: '#282b32', 
        textPrimary: '#EAEFF4',
        textSecondary: '#fff',
        lightindigo:'#1d233e',  
        borderColor: '#182D41', 
        inputBorder: '#646c79',
        containerBg: '#111C2D', 
        background: '#16293e', 
        hoverColor: '#333f55',
        surface: '#111C2D', 
        grey100: '#7C8FAC', 
        grey200: '#EAEFF4', 
        darkbg:'#111936',
        bglight:'#16293e',
        bgdark:'#16293e',
        ...SHARED_COLORS
    }
};

const DARK_PURPLE_THEME: ThemeTypes = {
    name: 'DARK_PURPLE_THEME',
    dark: true,
    variables: {
        'border-color': '#333F55',
        'border-opacity': 1,
    },
    colors: {
        primary: '#763EBD',
        secondary: '#95CFD5',
        info: '#5AC8FA',
        success: '#09C97F', 
        warning: '#F8B15D', 
        error: '#FB977D', 
        orange: '#FB977D', 
        indigo:'#8763DA',  
        lightprimary: '#1b394f',
        lightinfo:'#1a3247', 
        lightsecondary: '#2f3f4c',
        lightsuccess: '#102d35', 
        lighterror: '#72483d',
        lightwarning: '#282b32', 
        textPrimary: '#EAEFF4',
        textSecondary: '#fff',
        lightindigo:'#1d233e',  
        borderColor: '#182D41', 
        inputBorder: '#646c79',
        containerBg: '#111C2D', 
        background: '#16293e', 
        hoverColor: '#333f55',
        surface: '#111C2D', 
        grey100: '#7C8FAC', 
        grey200: '#EAEFF4', 
        darkbg:'#111936',
        bglight:'#16293e',
        bgdark:'#16293e',
        ...SHARED_COLORS
    }
};

const DARK_GREEN_THEME: ThemeTypes = {
    name: 'DARK_GREEN_THEME',
    dark: true,
    variables: {
        'border-color': '#333F55',
        'border-opacity': 1,
    },
    colors: {
        primary: '#0A7EA4',
        secondary: '#CCDA4E',
        info: '#5AC8FA',
        success: '#09C97F', 
        warning: '#F8B15D', 
        error: '#FB977D', 
        orange: '#FB977D',
        indigo:'#8763DA',  
        lightprimary: '#1b394f',
        lightinfo:'#1a3247', 
        lightsecondary: '#2f3f4c',
        lightsuccess: '#102d35', 
        lighterror: '#72483d',
        lightwarning: '#282b32', 
        textPrimary: '#EAEFF4',
        textSecondary: '#fff',
        lightindigo:'#1d233e',  
        borderColor: '#182D41', 
        inputBorder: '#646c79',
        containerBg: '#111C2D', 
        background: '#16293e', 
        hoverColor: '#333f55',
        surface: '#111C2D', 
        grey100: '#7C8FAC', 
        grey200: '#EAEFF4', 
        darkbg:'#111936',
        bglight:'#16293e',
        bgdark:'#16293e',
        ...SHARED_COLORS
    }
};

const DARK_CYAN_THEME: ThemeTypes = {
    name: 'DARK_CYAN_THEME',
    dark: true,
    variables: {
        'border-color': '#333F55',
        'border-opacity': 1,
    },
    colors: {
        primary: '#01C0C8',
        secondary: '#FB9678',
        info: '#5AC8FA',
        success: '#09C97F', 
        warning: '#F8B15D', 
        error: '#FB977D', 
        orange: '#FB977D',
        indigo:'#8763DA',  
        lightprimary: '#1b394f',
        lightinfo:'#1a3247', 
        lightsecondary: '#2f3f4c',
        lightsuccess: '#102d35', 
        lighterror: '#72483d',
        lightwarning: '#282b32', 
        textPrimary: '#EAEFF4',
        textSecondary: '#fff',
        lightindigo:'#1d233e',  
        borderColor: '#182D41', 
        inputBorder: '#646c79',
        containerBg: '#111C2D', 
        background: '#16293e', 
        hoverColor: '#333f55',
        surface: '#111C2D', 
        grey100: '#7C8FAC', 
        grey200: '#EAEFF4', 
        darkbg:'#111936',
        bglight:'#16293e',
        bgdark:'#16293e',
        ...SHARED_COLORS
    }
};

const DARK_ORANGE_THEME: ThemeTypes = {
    name: 'DARK_ORANGE_THEME',
    dark: true,
    variables: {
        'border-color': '#333F55',
        'border-opacity': 1,
    },
    colors: {
        primary: '#FA896B',
        secondary: '#0074BA',
        info: '#5AC8FA',
        success: '#09C97F', 
        warning: '#F8B15D', 
        error: '#FB977D', 
        orange: '#FB977D',
        indigo:'#8763DA',  
        lightprimary: '#1b394f',
        lightinfo:'#1a3247', 
        lightsecondary: '#2f3f4c',
        lightsuccess: '#102d35', 
        lighterror: '#72483d',
        lightwarning: '#282b32', 
        textPrimary: '#EAEFF4',
        textSecondary: '#fff',
        lightindigo:'#1d233e',  
        borderColor: '#182D41', 
        inputBorder: '#646c79',
        containerBg: '#111C2D', 
        background: '#16293e', 
        hoverColor: '#333f55',
        surface: '#111C2D', 
        grey100: '#7C8FAC', 
        grey200: '#EAEFF4', 
        darkbg:'#111936',
        bglight:'#16293e',
        bgdark:'#16293e',
        ...SHARED_COLORS
    }
};

export { DARK_BLUE_THEME, DARK_AQUA_THEME, DARK_ORANGE_THEME, DARK_PURPLE_THEME, DARK_GREEN_THEME, DARK_CYAN_THEME };
